import { FetchError } from '../../errors'

export const baseFetch = async <T>(
  url: string,
  options: RequestInit = {},
  token?: null | string,
  source?: string,
) => {
  const headers = new Headers(options.headers)
  headers.set('Content-Type', 'application/json')
  headers.set('Accept', 'application/json')

  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  }

  if (source) {
    headers.set('App-source', source)
  }

  const response = await fetch(url, { ...options, headers })

  // Read the body once
  const rawText = await response.text()

  // Handle non-OK responses
  if (!response.ok) {
    let errorBody: unknown

    try {
      errorBody = JSON.parse(rawText) // Parse as JSON if possible
    } catch {
      errorBody = rawText // Fallback to plain text
    }

    console.log(url, headers, errorBody)

    throw new FetchError(response.status, errorBody)
  }

  // Return undefined for empty bodies, or parse the body as JSON
  return rawText === '' ? (undefined as unknown as T) : (JSON.parse(rawText) as T)
}
